import { Config } from "@config";
import type { MutualFundResponseItem } from "@component/MutualFund/Calculator/types";
import { http, Alert, AlertHeading, LandingContainer, PromisePool } from "bm-ui-kit";
import kebabCase from "lodash/kebabCase";
import type { ReactNode } from "react";
import React from "react";

interface Props {
	isin: string;
}

interface State {
	status: "loading" | "redirecting" | "fail";
}

/**
 * @Routing
 *
 * @title "Befektetési alap - Adatlap"
 * @description ""
 * @route "/megtakaritasok/befektetesi-alap/:isin/"
 * @noIndex "true"
 */
export default class Landing extends React.Component<Props, State> {
	private readonly promisePool = new PromisePool();

	public constructor(props: Props) {
		super(props);
		this.state = { status: "redirecting" };
	}

	public componentDidMount(): void {
		if (!Config.isSsr()) {
			const { isin } = this.props;

			if (window.BM_DATAPAGE && window.BM_DATAPAGE[0]) {
				this.redirectToDataPage(isin, window.BM_DATAPAGE[0]?.name);
			} else {
				this.setState({
					status: "loading",
				});
				this.promisePool
					.add(this.loadProductData(isin))
					.then((res) => {
						this.setState({
							status: "redirecting",
						});

						this.redirectToDataPage(isin, res.name);
					})
					.catch(() => {
						this.setState({
							status: "fail",
						});

						this.promisePool.addTimeout().then(() => {
							window.location.href = `/megtakaritasok/befektetesi-alap/`;
						});
					});
			}
		}
	}

	public componentWillUnmount(): void {
		this.promisePool.cancel();
	}

	public render(): ReactNode {
		const { status } = this.state;

		switch (status) {
			case "redirecting":
				return (
					<LandingContainer>
						<Alert icon="auto" size="lg" variant="danger">
							Egy kis türelmet kérünk!
							<br />
							Hamarosan tovább irányítunk a termék adatlaphoz...
						</Alert>
					</LandingContainer>
				);

			case "fail":
				return (
					<LandingContainer>
						<Alert icon="auto" size="lg" variant="danger">
							<AlertHeading>Sajnos a keresett termék már nem érhető el!</AlertHeading>
							Hamarosan visszairányítjuk a kalkulátorunkhoz...
						</Alert>
					</LandingContainer>
				);
			case "loading":
			default:
				return (
					<LandingContainer>
						<Alert icon="auto" size="lg" variant="danger">
							<AlertHeading>Egy kis türelmet kérünk!</AlertHeading>
							Keressük a terméket...
						</Alert>
					</LandingContainer>
				);
		}
	}

	private loadProductData(isin: string): Promise<MutualFundResponseItem> {
		return http.get(
			Config.getApiUrl(
				`/api/public/mutual-fund/api-for-bankmonitor-hu/v4/mutual-funds/details/${encodeURIComponent(isin)}`,
			),
		);
	}

	private redirectToDataPage(isin: string, name: string): void {
		window.location.href = `/megtakaritasok/befektetesi-alap/${isin}/${kebabCase(name)}/`;
	}
}
